import { ParameterType } from './../../../../widgets/administration/supplementary-equipment/model/parameter-type.enum';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { DialogService, SelectFieldOption } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { ParameterSelectionDialogData, TransportOptionParameterSelectionComponent } from '../transport-option-parameter-selection/transport-option-parameter-selection.component';
import { TransportOption, TransportOptionParameter, TransportOptionParameterValue } from '../../transport-options-panel.model';

@Component({
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TransportOptionParameterComponent),
      multi: true,
    },
  ],
  selector: 'app-transport-option-parameter',
  templateUrl: './transport-option-parameter.component.html',
  styleUrls: ['./transport-option-parameter.component.scss'],
  standalone: false
})
export class TransportOptionParameterComponent implements OnInit, ControlValueAccessor {

  @Input() transportOption?: TransportOption;

  @Input() parameter?: TransportOptionParameter;

  values = new Array<string>();

  selectFieldOptions = new Array<SelectFieldOption>();

  parameterFormGroup = new FormGroup({
    multiSelect: new FormControl(null, [Validators.required]),
    singleSelect: new FormControl(null, [Validators.required]),
    text: new FormControl(null, [Validators.required])
  })

  constructor(
    public translationService: TranslationService,
    public dialogService: DialogService
  ) { }

  ngOnInit(): void {

    if ('SINGLE_SELECT' === this.parameter?.type) {
      for (const value of this.parameter.parameterValues) {
        this.selectFieldOptions.push(new SelectFieldOption({  labelDictionaryKey: 'dd.transport-option-parameter-value.' + value.id + ".value", value : ''+value.id }))
      }
    }

    this.parameterFormGroup.valueChanges.subscribe(values => {
      if (this.parameter?.type === 'TEXT') {
        this._onChange([values.text]);
      }
      if (this.parameter?.type === 'SINGLE_SELECT') {
        this._onChange([values.singleSelect]);
      }
    });
  }

  showSelectionDialog() {
    this.dialogService.openDefault(
      TransportOptionParameterSelectionComponent,
      new ParameterSelectionDialogData({
        available: this.parameter!.parameterValues, selected: this.values
      }))
      .afterClosed().subscribe(result => {
        if (result != null) {
          this.values = result as string[];
          this.getTextValue();
          this._onChange(this.values);
          this.parameterFormGroup.patchValue({ multiSelect: this.getTextValue() });
        }
      });
  }

  getTextValue() : string {
    let string = '';
    this.values.forEach((value, index) => {
      if (index > 0) {
        string += ', ';
      }
      console.log('processing value', value);
      string += this.translationService.translate('dd.transport-option-parameter-value.' + value + '.value');
    });
    return string;
  }

  public writeValue(value: Array<string> | null): void {
    if (value != null) {
      this.values = value;
    } else {
      this.values = new Array<string>();
    }
    if (this.parameter?.type === 'TEXT') {
      if (this.values.length > 0) {
        this.parameterFormGroup.patchValue({ text: this.values[0] });
      } else {
        this.parameterFormGroup.patchValue({});
      }
    } else if (this.parameter?.type === 'SINGLE_SELECT') {
      if (this.values.length > 0) {
        this.parameterFormGroup.patchValue({ singleSelect: this.values[0] });
      } else {
        this.parameterFormGroup.patchValue({});
      }
    } else if (this.parameter?.type === 'MULTI_SELECT') {
      this.parameterFormGroup.patchValue({ multiSelect: this.getTextValue() });
    }
  }

  private _onChange = (_value: Array<string> | null): void => undefined;
  public registerOnChange(fn: (value: Array<string> | null) => void): void {
    this._onChange = fn;
  }

  /** It's called in the component template when we have a "blur" or "input" event */
  public onTouched = (): void => undefined;
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

}
